import * as angular from "angular";
import {IController} from "angular";
import {FulfillmentTaskModel} from "../../models/fulfillment-task.model";

export class FulfillmentLineTaskAdditionsComponent implements IController {

  fulfillmentLineId: string;
  task: FulfillmentTaskModel;
  taskAdditionsMap: {} = {}

  constructor() {
  }

  $onInit() {
    this._initLineAdditionsData();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.task && !changes.task.isFirstChange()) {
      this._initLineAdditionsData();
    }
  }

  private _initLineAdditionsData() {
    this.task.additions.forEach(a => {
      if (!this.taskAdditionsMap[a.name]) {
        this.taskAdditionsMap[a.name] = 1;
      } else {
        this.taskAdditionsMap[a.name] += 1
      }
    })
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineTaskAdditions', {
    bindings: {
      fulfillmentLineId: '<',
      task: '<'
    },
    template: require('./fulfillment-line-task-additions.html').default,
    controller: FulfillmentLineTaskAdditionsComponent
  });
